export default { sha: '89a0c1cc89ef3843d85c400417231a841783ca8c', buildNumber: 'undefined' }
